import { BlockTypes } from "modules/MainSurveyEditor/helpers/blocks"

export enum ConditionActionTypes {
    Hide = 'hid',
    Lock = 'lck',
}

export enum ConditionOperatorTypes {
    Is = 'is',
    IsNot = 'is_not',
    IsEmpty = 'is_empty',
    IsNotEmpty = 'is_not_empty',
}

export const ConditionOperatorTypeTitles = {
    [ConditionOperatorTypes.Is]: 'Is',
    [ConditionOperatorTypes.IsNot]: 'Is not',
    [ConditionOperatorTypes.IsEmpty]: 'Is empty',
    [ConditionOperatorTypes.IsNotEmpty]: 'Is not empty',
}

export const AllowedBlockTypes = [
    BlockTypes.SingleSelect,
    BlockTypes.MultiSelect,
]